import { findInSitemap } from '@pm2/api';

function findPageDescriptorById(state, id) {
  return findInSitemap(state.rootDescriptors, (it) => it.id === id);
}

export { findPageDescriptorById };
//# sourceMappingURL=util.find-page-descriptor-by-id.js.map
